export const Permissions = {
  // Basic application access - required for most functionality
  APP_USER: 'APP_USER',

  // System administrator - full access to everything
  SYSADMIN: 'SYSADMIN',

  // Member management permissions
  MEMBER_UPDATE: 'MEMBER_UPDATE',
  MEMBER_READ_ONLY: 'MEMBER_READ_ONLY',
  MEMBER_DELETE: 'MEMBER_DELETE',

  // Work hours management
  WORKHOURS_UPDATE: 'WORKHOURS_UPDATE',

  // Invoice/Billing management
  GEN_INVOICE: 'GEN_INVOICE'
} as const;

export type PermissionType = (typeof Permissions)[keyof typeof Permissions];
